import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import user from '../user/reducer';
import cow from '../cows/reducer';
import cowFilter from '../cowFilters/reducer';
import notifications from '../notifications/reducer';
import admin from '../admin/reducer';
import scoreAdmin from '../admin/scoreDefinitions/reducer';
import nav from '../header/reducer';
import userSagas from '../user/sagas';
import cowSagas from '../cows/sagas';
import adminSagas from '../admin/sagas';
import notificationSagas from '../notifications/sagas';
import adminScoreSagas from '../admin/scoreDefinitions/sagas';

const rootReducer = combineReducers({
  user, cow, cowFilter, admin, notifications, nav, scoreAdmin
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(userSagas);
sagaMiddleware.run(cowSagas);
sagaMiddleware.run(adminSagas);
sagaMiddleware.run(notificationSagas);
sagaMiddleware.run(adminScoreSagas);

export default store;
